module Hereabout.UI.Components.UserProfileComponent where

import Prelude

import Control.Monad.Reader (asks)
import Data.Const (Const)
import Data.Maybe (Maybe(..))
import Effect (Effect)
import Effect.Class (class MonadEffect, liftEffect)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Hereabout.Effects (class RenderExternalUserComponents, class UserSession, currentUser, openUserProfile, renderUserProfile)
import Hereabout.Types (Content(..), User(..))
import Hereabout.UI.Bits (renderIcon)
import Hereabout.UI.Bulma.Classes as Bulma
import Hereabout.UI.Components.RawHTMLComponent as RawHTMLComp
import Markdown.Markdown (sanitisedHTMLFromContent)
import Type.Proxy (Proxy(..))
import Web.HTML (HTMLElement)


type State = 
  { user :: Maybe User
  , currentTab :: UserProfileTab
  }

data Action 
  = InitComponent
  | SelectTab UserProfileTab
  | OpenUserProfile

type Slot id = forall q o. H.Slot q o id

type ChildSlots =
  ( rawHTMLComp :: RawHTMLComp.Slot Unit
  )

data UserProfileTab
  = MyEventsTab
  | MyCommunitiesTab
  | MyCommentsTab

derive instance userProfileTabEq :: Eq UserProfileTab

component :: forall o m q. MonadEffect m => UserSession m => RenderExternalUserComponents m => H.Component q {} o m
component = 
  H.mkComponent
    { initialState: \c -> { user : Nothing, currentTab : MyEventsTab }
    , render
    , eval: H.mkEval H.defaultEval
      { handleAction = handleAction
      , initialize = Just InitComponent
      }
    }

userProfileRef ∷ H.RefLabel
userProfileRef = H.RefLabel "userProfileRef"

render :: forall m. MonadEffect m => State -> H.ComponentHTML Action ChildSlots m
render state =  
  case state.user of
    Just user -> renderUser state.currentTab user
    Nothing -> HH.div_ []

renderUser :: forall m. MonadEffect m => UserProfileTab -> User ->  H.ComponentHTML Action ChildSlots m
renderUser tab (User user)  = 
  HH.section [ HP.classes [Bulma.section] ]
  [ HH.figure [ HP.classes [ Bulma.image, Bulma.is128x128, Bulma.mb3 ] ]
    [ HH.img [ HP.classes [ Bulma.isRounded ], HP.src user.imageUrl ]
    ]
  , HH.h1 [ HP.classes [ Bulma.title] ]
    [ HH.text user.fullName
    ]
  , HH.p_
    [ HH.a [ HE.onClick $ \_ -> OpenUserProfile ]
      [ HH.text "Account Settings"
      ]
    ]
  , HH.div [ HP.classes [ Bulma.tabs, Bulma.isToggle, Bulma.isCentered, Bulma.isMedium ] ]
    [ HH.ul_ 
      [ HH.li [ HP.classes $ [] <> activeClasses tab MyEventsTab ]
        [ HH.a [ HE.onClick $ \_ -> SelectTab MyEventsTab ]
          [ renderIcon "fa-calendar-days" $ HH.text "My Events"
          ]
        ]
      , HH.li [ HP.classes $ [] <> activeClasses tab MyCommunitiesTab ]
        [ HH.a [ HE.onClick $ \_ -> SelectTab MyCommunitiesTab  ]
          [ renderIcon "fa-tree-city" $ HH.text "My Communities"
          ]
        ]
      , HH.li [ HP.classes $ [] <> activeClasses tab MyCommentsTab ]
        [ HH.a [ HE.onClick $ \_ -> SelectTab MyCommentsTab ]
          [ renderIcon "fa-comments" $ HH.text "My Comments"
          ]
        ]
      ]
    ]
  ]
    where
      activeClasses a b | a == b = [ Bulma.isActive ]
      activeClasses _ _ = []
      




handleAction :: forall cs o m. MonadEffect m => UserSession m => RenderExternalUserComponents m => Action -> H.HalogenM State Action cs o m Unit
handleAction InitComponent = do
  maybeUser <- H.lift $ currentUser
  H.modify_ _ { user = maybeUser}
handleAction (SelectTab tab) = do
  H.modify_ _ { currentTab = tab }
handleAction OpenUserProfile = do
  H.lift $ openUserProfile

